import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export const PublicLayout = ({ children }) => (
  <div className="min-h-screen bg-white text-slate-900 flex flex-col">
    <Header />
    <main className="flex-1 pt-20">{children}</main>
    <Footer />
  </div>
);
